<template>
  <div class="h-100">
    <System200 v-if="!isCustom" v-bind="$attrs" v-on="$listeners" />
    <Custom200
      v-if="isCustom"
      :page-content="pageContent"
      v-bind="$attrs"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import System200 from './_200/system-200.vue'
import Custom200 from './_200/custom-200.vue'
import BrandingMixin from '@src/mixins/branding'
import { QUERY_STRING_TEXT } from '@src/js/static-page-script'

export default {
  name: '200',
  components: { System200, Custom200 },
  mixins: [BrandingMixin],
  page: {
    title: '200',
    meta: [{ name: 'description', content: '200' }],
  },
  data() {
    return {
      isCustom: false,
      pageContent: undefined,
    }
  },
  watch: {
    'branding.pagesCustomization': {
      immediate: true,
      handler(newValue) {
        if (
          this.$route.query[QUERY_STRING_TEXT] &&
          this.$route.query[QUERY_STRING_TEXT] === 'true'
        ) {
          return
        }
        const currentPage = newValue.find((v) => v.pageType === 'page_200')
        if (currentPage.enabled && currentPage.pageContent) {
          this.isCustom = true
          this.pageContent = currentPage.pageContent
        }
      },
    },
  },
}
</script>
